import type { UserProfile } from "@/services/api/profile";
import { create } from "zustand";
import { persist } from "zustand/middleware";

// Header组件需要的用户信息类型
interface HeaderUserInfo {
  name?: string;
  phone?: string;
  avatarUrl?: string;
  company?: string;
  email?: string;
}

type AuthState = {
  token: string | null;
  user: HeaderUserInfo | null;
  setToken: (token: string | null) => void;
  setUser: (user: UserProfile | null) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setToken: (token) => set({ token }),
      setUser: (user) => {
        if (user) {
          // 将UserProfile字段映射到Header组件需要的字段
          const mappedUser = {
            name: user.name,
            phone: user.mobile,
            avatarUrl: user.avatar,
            company: user.beta_data?.company_name,
            email: user.email,
          };
          set({ user: mappedUser });
        } else {
          set({ user: null });
        }
      },
      logout: () => {
        set({ token: null, user: null });
        // 删除整个 localStorage
        localStorage.clear();
        // 刷新页面
        window.location.reload();
      },
    }),
    {
      name: "ztrank-auth-store",
      partialize: (s) => ({ token: s.token, user: s.user }),
    }
  )
);
